// extracted by mini-css-extract-plugin
module.exports = {"h2":"Topography_h2__1DTqa","h3":"Topography_h3__26g4M","h4":"Topography_h4__10cqG"};